import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconEventBusy.tsx
const OutlinedFilledEventBusy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z" })
});
const OutlinedEventBusy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const RoundedFilledEventBusy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m480-310-70 72q-11 11-25 10.5T360-239q-11-11-11-25.5t11-25.5l70-70-72-71q-11-10-10.5-24.12.5-14.12 11.5-25.88 11-11 25.5-11t25.5 11l70 71 71-72q10-11 24.12-11 14.12 0 25.88 11 11 11.51 11 25.76Q612-442 601-431l-71 71 72 70q11 11 11 25t-11.41 25q-11.41 11-25.5 11T551-240l-71-70ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-17.15 12.19-29.08 12.2-11.92 29-11.92Q303-906 315-894.08q12 11.93 12 29.08v19h306v-19q0-17.15 12.19-29.08 12.2-11.92 29-11.92Q691-906 703-894.08q12 11.93 12 29.08v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z" })
});
const RoundedEventBusy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m480-310-70 72q-11 11-25 10.5T360-239q-11-11-11-25.5t11-25.5l70-70-72-71q-11-10-10.5-24.12.5-14.12 11.5-25.88 11-11 25.5-11t25.5 11l70 71 71-72q10-11 24.12-11 14.12 0 25.88 11 11 11.51 11 25.76Q612-442 601-431l-71 71 72 70q11 11 11 25t-11.41 25q-11.41 11-25.5 11T551-240l-71-70ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const SharpFilledEventBusy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Z" })
});
const SharpEventBusy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "m385-214-51-51 96-95-96-95 51-52 95 97 95-97 52 52-97 95 97 95-52 51-95-96-95 96ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const componentMap = {
	outlined: OutlinedEventBusy,
	"outlined-fill": OutlinedFilledEventBusy,
	rounded: RoundedEventBusy,
	"rounded-fill": RoundedFilledEventBusy,
	sharp: SharpEventBusy,
	"sharp-fill": SharpFilledEventBusy
};
const IconEventBusy = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconEventBusy };